/* MenaHub Quick Buy — WhatsApp Buy + 1-Click Buy buttons (jumbosouq-style).
 *
 * Config from /api/quickbuy_config.php (admin → backend settings → Quick Buy):
 * per-feature enable, markets (qa/sa), languages (en/ar), WhatsApp number.
 * Product scope (categories/brands/vendors) is enforced SERVER-side at order
 * time; buttons render wherever the feature itself is on.
 *
 * Cached in localStorage mh_qb_cfg; an inline <head> script in theme.liquid
 * reads that cache before first paint and sets html.mh-qb-on / html.mh-qb-wa-on
 * so the button row's space is reserved with no layout shift.
 *
 * 1-Click flow: login → one-time consent + default address + payment method
 * (stored via /api/quickbuy_prefs.php) → POST /api/quickbuy_order.php.
 *   COD default  → order placed instantly (4s cancellable countdown toast).
 *   Card default → item added to cart → prefilled custom checkout (Tap).
 *   PayLater-eligible products first ask: PayLater or Full payment.
 */
(function () {
  'use strict';
  var API = 'https://admin.menahub.com/api';
  var IS_AR = /^\/ar(\/|$)/.test(location.pathname);
  var LANG = IS_AR ? 'ar' : 'en';

  var T = IS_AR ? {
    oneclick: 'شراء سريع', wa: 'اطلب عبر واتساب', cart: 'أضف إلى السلة',
    buyPaylater: 'اشترِ بالتقسيط', buyOn: 'اشترِ عبر',
    login: 'سجّل الدخول لاستخدام الشراء بنقرة واحدة',
    consentTitle: 'موافقة الشراء بنقرة واحدة',
    consentBody: 'لتفعيل الشراء بنقرة واحدة نحتاج موافقتك على حفظ عنوان التوصيل الافتراضي وطريقة الدفع المفضلة. سيتم إتمام مشترياتك القادمة فوراً بنقرة واحدة. تُحفظ معلوماتك بأمان وتُستخدم فقط لمعالجة طلباتك وفق سياسة الخصوصية.',
    consentAgree: 'أوافق على استخدام الشراء بنقرة واحدة وحفظ عنواني وطريقة الدفع بأمان',
    allow: 'موافق', cancel: 'إلغاء',
    addrTitle: 'اختر عنوان التوصيل الافتراضي',
    addrNone: 'لا توجد عناوين محفوظة — أضف عنواناً أولاً من صفحة عناويني.',
    addrManage: 'إدارة العناوين',
    payTitle: 'طريقة الدفع الافتراضية',
    payCod: 'الدفع عند الاستلام', payCodDesc: 'يتم الطلب فوراً بنقرة واحدة',
    payCard: 'بطاقة', payCardDesc: 'صفحة دفع معبأة مسبقاً — نقرة ثم ادفع',
    save: 'حفظ وتفعيل',
    placing: 'جارٍ إتمام الطلب…', cancelBtn: 'إلغاء',
    placed: 'تم الطلب!', orderNo: 'رقم الطلب',
    plTitle: 'كيف تريد الدفع؟',
    plPaylater: 'PayLater — أقساط', plFull: 'دفعة كاملة', plInstall: 'أقساط',
    waMsg: 'مرحباً! أريد طلب هذا المنتج:',
    qty: 'الكمية', variant: 'اختر النوع', confirm: 'تأكيد',
    notify: 'أعلمني عند التوفر', notifyTitle: 'أعلمني عند توفر المنتج',
    notifyBody: 'أدخل بريدك الإلكتروني وسنراسلك فور توفر هذا المنتج.',
    notifyBtn: 'أعلمني', notifyOk: 'تم! سنراسلك فور توفره.',
    waQty: 'الكمية', buyOptions: 'خيارات الشراء', total: 'الإجمالي',
    delivery: 'التوصيل', freeDel: 'توصيل مجاني',
    waOrderId: 'رقم طلب واتساب', waDate: 'التاريخ', waProduct: 'المنتج',
    waPrice: 'السعر', waDelType: 'نوع التوصيل',
    waName: 'الاسم', waPhone: 'الهاتف', waEmail: 'البريد الإلكتروني'
  } : {
    oneclick: '1-Click', wa: 'Order on WhatsApp', cart: 'Add to Cart',
    buyPaylater: 'Buy on PayLater', buyOn: 'Buy on',
    login: 'Sign in to use 1-Click Buy',
    consentTitle: '1-Click Checkout Consent',
    consentBody: 'To enable 1-Click Buy we need your consent to securely store your default shipping address and preferred payment method. Future purchases complete instantly with just one click. Your information is stored securely and used only for processing your orders in accordance with our privacy policy.',
    consentAgree: 'I agree to use 1-Click Buy and allow my delivery address and payment preference to be stored securely',
    allow: 'Allow', cancel: 'Cancel',
    addrTitle: 'Choose your default delivery address',
    addrNone: 'No saved addresses yet — add one from My Addresses first.',
    addrManage: 'Manage addresses',
    payTitle: 'Default payment method',
    payCod: 'Cash on Delivery', payCodDesc: 'Order placed instantly with one click',
    payCard: 'Card', payCardDesc: 'Prefilled payment page — one click, then pay',
    save: 'Save & Enable',
    placing: 'Placing your order…', cancelBtn: 'Cancel',
    placed: 'Order placed!', orderNo: 'Order no.',
    plTitle: 'How would you like to pay?',
    plPaylater: 'PayLater — installments', plFull: 'Full payment', plInstall: 'installments',
    waMsg: 'Hi! I would like to order this product:',
    qty: 'Quantity', variant: 'Choose option', confirm: 'Confirm',
    notify: 'Notify me', notifyTitle: 'Notify me when available',
    notifyBody: 'Leave your email and we will let you know the moment this product is back in stock.',
    notifyBtn: 'Notify me', notifyOk: 'Done! We will email you when it is back.',
    waQty: 'Qty', buyOptions: 'Buying Options', total: 'Total',
    delivery: 'Delivery', freeDel: 'FREE DELIVERY applies',
    waOrderId: 'WhatsApp Order ID', waDate: 'Date', waProduct: 'Product',
    waPrice: 'Price', waDelType: 'Delivery type',
    waName: 'Name', waPhone: 'Phone', waEmail: 'Email'
  };

  /* ── Config (SWR via localStorage; head snippet consumed the cache) ── */
  var CFG = null;
  // The cache writes a timestamp but never checked it, so a config captured
  // while WhatsApp / 1-Click were ON kept painting those buttons on every
  // later visit — indefinitely, and before the network answer could correct
  // it. Switching a feature off then took effect for new visitors only.
  var CFG_TTL = 600000; // 10 min, matching quickbuy_config.php's own TTL
  function readCfgCache() {
    try {
      var raw = localStorage.getItem('mh_qb_cfg');
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.c) return null;
      if (!o.t || (Date.now() - o.t) > CFG_TTL) return null;   // stale → ask
      return o.c;
    } catch (e) { return null; }
  }
  function applyCfgClasses(c) {
    var mkt = market();
    var on = function (f) {
      return !!(c && c[f] && c[f].enabled &&
        (c[f].markets || []).indexOf(mkt) !== -1 &&
        (c[f].langs || []).indexOf(LANG) !== -1);
    };
    document.documentElement.classList.toggle('mh-qb-on', on('oneclick'));
    document.documentElement.classList.toggle('mh-qb-wa-on', on('whatsapp'));
  }
  function loadCfg(cb) {
    CFG = readCfgCache();
    if (CFG) { applyCfgClasses(CFG); cb && cb(); }
    fetch(API + '/quickbuy_config.php', { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.success) return;
        CFG = d.config;
        try { localStorage.setItem('mh_qb_cfg', JSON.stringify({ t: Date.now(), c: d.config })); } catch (e) {}
        applyCfgClasses(CFG);
        if (!readCfgCache()) return;
        cb && cb();
      })
      .catch(function () {});
  }
  function market() {
    var m = document.cookie.match(/(?:^|; )mh_market=([^;]*)/);
    return (m && decodeURIComponent(m[1]) === 'sa') ? 'sa' : 'qa';
  }
  function featureOn(f) {
    return !!(CFG && CFG[f] && CFG[f].enabled &&
      (CFG[f].markets || []).indexOf(market()) !== -1 &&
      (CFG[f].langs || []).indexOf(LANG) !== -1);
  }
  function token() {
    try { return localStorage.getItem('mh_token') || ''; } catch (e) { return ''; }
  }

  /* ── Modal scaffolding ──────────────────────────────────────────── */
  function modal(innerBuilder) {
    var ov = document.createElement('div');
    ov.className = 'mh-qb-overlay';
    ov.setAttribute('dir', IS_AR ? 'rtl' : 'ltr');
    var box = document.createElement('div');
    box.className = 'mh-qb-modal';
    ov.appendChild(box);
    // Scroll-lock on the ROOT element: html{overflow:hidden} freezes the
    // page exactly where it is — no scroll change, no scroll events, so
    // the sticky header doesn't animate and there is zero jump on open or
    // close. (Pinning the body moved window scroll to 0 = visible jerk;
    // body overflow:hidden collapsed the scroller entirely.)
    var docEl = document.documentElement;
    var prevOverflow = docEl.style.overflow;
    function close() { ov.remove(); docEl.style.overflow = prevOverflow; }
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    innerBuilder(box, close);
    document.body.appendChild(ov);
    docEl.style.overflow = 'hidden';
    return close;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function btn(label, primary, onClick) {
    var b = el('button', 'mh-qb-btn' + (primary ? ' mh-qb-btn--primary' : ''), label);
    b.type = 'button';
    b.addEventListener('click', onClick);
    return b;
  }

  /* Full-screen "Redirecting to WhatsApp…" overlay — shown while the order is
     minted in the background, until WhatsApp opens. */
  var _waOv = null;
  function waRedirectOverlay(show) {
    if (show) {
      if (_waOv) return;
      _waOv = el('div', 'mh-qb-waov');
      var card = el('div', 'mh-qb-waov-card');
      var ic = svgIcon([WA_PATH]); ic.setAttribute('class', 'mh-qb-waov-icon');
      var sp = el('div', 'mh-qb-waov-spin');
      card.appendChild(ic);
      card.appendChild(el('div', 'mh-qb-waov-txt', IS_AR ? 'يتم تحويلك إلى واتساب، الرجاء الانتظار…' : 'Redirecting to WhatsApp, please wait…'));
      card.appendChild(sp);
      _waOv.appendChild(card);
      document.body.appendChild(_waOv);
    } else if (_waOv) {
      _waOv.remove(); _waOv = null;
    }
  }

  /* ── Consent + setup wizard ─────────────────────────────────────── */
  function openSetup(done) {
    modal(function (box, close) {
      // Step 1: consent (screenshot style — text, checkbox, Cancel/Allow)
      box.appendChild(el('div', 'mh-qb-title', T.consentTitle));
      box.appendChild(el('p', 'mh-qb-body', T.consentBody));
      var lab = el('label', 'mh-qb-check');
      var cb = document.createElement('input'); cb.type = 'checkbox';
      lab.appendChild(cb); lab.appendChild(el('span', '', T.consentAgree));
      box.appendChild(lab);
      var row = el('div', 'mh-qb-actions');
      row.appendChild(btn(T.cancel, false, close));
      var allow = btn(T.allow, true, function () {
        if (!cb.checked) { cb.parentElement.classList.add('mh-qb-shake'); setTimeout(function(){ cb.parentElement.classList.remove('mh-qb-shake'); }, 500); return; }
        stepAddress(box, close, done);
      });
      row.appendChild(allow);
      box.appendChild(row);
    });
  }

  function stepAddress(box, close, done) {
    box.textContent = '';
    box.appendChild(el('div', 'mh-qb-title', T.addrTitle));
    var list = el('div', 'mh-qb-list', '…');
    box.appendChild(list);
    fetch(API + '/addresses.php?action=list', { headers: { Authorization: 'Bearer ' + token() } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        list.textContent = '';
        var addrs = (d && (d.addresses || d.data)) || [];
        if (!addrs.length) {
          list.appendChild(el('p', 'mh-qb-body', T.addrNone));
          var mg = el('a', 'mh-qb-link', T.addrManage);
          mg.href = (IS_AR ? '/ar' : '') + '/pages/my-addresses';
          list.appendChild(mg);
          return;
        }
        var chosen = null;
        addrs.forEach(function (a) {
          var lab = el('label', 'mh-qb-addr');
          var r = document.createElement('input'); r.type = 'radio'; r.name = 'mhqb-addr'; r.value = a.id;
          if (a.is_default == 1 && chosen === null) { r.checked = true; chosen = a.id; }
          r.addEventListener('change', function () { chosen = a.id; });
          lab.appendChild(r);
          var txt = el('div', '');
          txt.appendChild(el('div', 'mh-qb-addr-name', (a.label || '') + ' ' + [a.first_name, a.last_name].filter(Boolean).join(' ')));
          txt.appendChild(el('div', 'mh-qb-addr-line', [a.street || a.address1, a.area || a.address2, a.city].filter(Boolean).join(', ')));
          if (a.phone) txt.appendChild(el('div', 'mh-qb-addr-line', a.phone));
          lab.appendChild(txt);
          list.appendChild(lab);
        });
        if (chosen === null && addrs[0]) {
          list.querySelector('input[type=radio]').checked = true;
          chosen = addrs[0].id;
        }
        var row = el('div', 'mh-qb-actions');
        row.appendChild(btn(T.cancel, false, close));
        row.appendChild(btn(IS_AR ? 'التالي' : 'Next', true, function () {
          if (chosen) stepPayment(box, close, done, chosen);
        }));
        box.appendChild(row);
      })
      .catch(function () { list.textContent = 'Error — try again'; });
  }

  function stepPayment(box, close, done, addressId) {
    var old = box.querySelector('.mh-qb-actions'); if (old) old.remove();
    box.querySelector('.mh-qb-title').textContent = T.payTitle;
    box.querySelector('.mh-qb-list').textContent = '';
    var list = box.querySelector('.mh-qb-list');
    var chosen = 'cod';
    [['cod', T.payCod, T.payCodDesc], ['card', T.payCard, T.payCardDesc]].forEach(function (opt) {
      var lab = el('label', 'mh-qb-addr');
      var r = document.createElement('input'); r.type = 'radio'; r.name = 'mhqb-pay'; r.value = opt[0];
      if (opt[0] === 'cod') r.checked = true;
      r.addEventListener('change', function () { chosen = opt[0]; });
      lab.appendChild(r);
      var txt = el('div', '');
      txt.appendChild(el('div', 'mh-qb-addr-name', opt[1]));
      txt.appendChild(el('div', 'mh-qb-addr-line', opt[2]));
      lab.appendChild(txt);
      list.appendChild(lab);
    });
    var row = el('div', 'mh-qb-actions');
    row.appendChild(btn(T.cancel, false, close));
    row.appendChild(btn(T.save, true, function () {
      fetch(API + '/quickbuy_prefs.php', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'save', payment_method: chosen, default_address_id: addressId, consent: 1 })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.success) { close(); done && done(); }
        else alert((d && d.message) || 'Could not save — try again');
      }).catch(function () { alert('Network error'); });
    }));
    box.appendChild(row);
  }

  /* ── Product JSON (variants) — sessionStorage cached ────────────── */
  function productJson(handle, cb) {
    // Pin the price context to the market the SITE is displaying: a stale
    // Shopify `localization` cookie (e.g. after trying the Saudi selector)
    // otherwise makes .js return the +30% SA price list while the page
    // shows Qatar prices. ?country= overrides the cookie.
    var country = market() === 'sa' ? 'SA' : 'QA';
    var key = 'mh:qbp:' + country + ':' + handle;
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.p && (Date.now() - o.t) < 30 * 60 * 1000) { cb(o.p); return; }
      }
    } catch (e) {}
    fetch('/products/' + encodeURIComponent(handle) + '.js?country=' + country)
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
        cb(p);
      })
      .catch(function () { cb(null); });
  }
  function money(cents) {
    return 'QAR ' + (cents / 100).toLocaleString('en', { minimumFractionDigits: 2 });
  }

  /* ── Delivery rules (fee + free-above threshold) — cached 10 min ──── */
  var SHIP = null;
  function shippingCfg(cb) {
    if (SHIP) { cb(SHIP); return; }
    try {
      var raw = sessionStorage.getItem('mh:qbship');
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.d && (Date.now() - o.t) < 10 * 60 * 1000) { SHIP = o.d; cb(SHIP); return; }
      }
    } catch (e) {}
    fetch(API + '/checkout_config.php', { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var del = d && d.data && d.data.delivery;
        if (!del) { cb(null); return; }
        SHIP = del;
        try { sessionStorage.setItem('mh:qbship', JSON.stringify({ t: Date.now(), d: del })); } catch (e) {}
        cb(SHIP);
      })
      .catch(function () { cb(null); });
  }

  /* ── Quantity / variant picker.
     opts.qty  → show a quantity stepper (cart + WhatsApp flows).
     Variants list only when the product has real options (1-Click included).
     cb({ variantId, variantTitle, qty }) — variantId null on fetch failure. */
  function qtyVariantModal(handle, opts, cb) {
    productJson(handle, function (p) {
      var variants = (p && p.variants) ? p.variants.filter(function (v) { return v.available !== false; }) : [];
      if (!variants.length && p && p.variants && p.variants.length) variants = p.variants;
      var multi = variants.length > 1;
      if (!multi && !opts.qty) {
        // Nothing to ask — proceed directly (1-Click on single-variant items).
        cb({ variantId: variants[0] ? variants[0].id : null, variantTitle: '', qty: 1 });
        return;
      }
      modal(function (box, close) {
        box.appendChild(el('div', 'mh-qb-title', multi ? T.variant : T.qty));
        var chosen = variants[0] || null;

        // Product summary — photo, name, unit price — so the shopper always
        // sees WHAT they're buying before confirming qty/variant.
        var unitEl = null, totalEl = null;
        if (p) {
          var sum = el('div', 'mh-qb-prod');
          var src = p.featured_image || (p.images && p.images[0]) || '';
          if (src) {
            var img = document.createElement('img');
            img.src = src; img.alt = p.title || ''; img.loading = 'lazy';
            sum.appendChild(img);
          }
          var meta = el('div', 'mh-qb-prod-meta');
          meta.appendChild(el('div', 'mh-qb-prod-title', p.title || ''));
          unitEl = el('div', 'mh-qb-prod-price', money(chosen ? chosen.price : p.price));
          meta.appendChild(unitEl);
          sum.appendChild(meta);
          box.appendChild(sum);
        }
        var ship = null, delEl = null;
        function refreshPrices() {
          var unit = chosen ? chosen.price : (p ? p.price : 0);
          if (unitEl) unitEl.textContent = money(unit);
          var sub = unit * qty;
          var fee = 0;
          if (ship) {
            // Digital items and orders over the free-minimum ship free.
            var digital = chosen && chosen.requires_shipping === false;
            var free = !!ship.free_delivery_override || digital ||
              sub >= (ship.free_minimum || 0) * 100;
            fee = free ? 0 : (ship.fee || 0) * 100;
            if (delEl) {
              if (free) { delEl.textContent = T.freeDel; delEl.className = 'mh-qb-delval mh-qb-delval--free'; }
              else { delEl.textContent = money(fee); delEl.className = 'mh-qb-delval'; }
            }
          }
          if (totalEl) totalEl.textContent = money(sub + fee);
        }
        if (multi) {
          var list = el('div', 'mh-qb-list');
          variants.forEach(function (v, i) {
            var lab = el('label', 'mh-qb-addr');
            var r = document.createElement('input'); r.type = 'radio'; r.name = 'mhqb-var';
            if (i === 0) r.checked = true;
            r.addEventListener('change', function () { chosen = v; refreshPrices(); });
            lab.appendChild(r);
            var txt = el('div', '');
            txt.appendChild(el('div', 'mh-qb-addr-name', v.title));
            txt.appendChild(el('div', 'mh-qb-addr-line', money(v.price)));
            lab.appendChild(txt);
            list.appendChild(lab);
          });
          box.appendChild(list);
        }
        var qty = 1;
        if (opts.qty) {
          var qrow = el('div', 'mh-qb-qtyrow');
          qrow.appendChild(el('span', 'mh-qb-addr-name', T.qty));
          var minus = btn('−', false, function () { qty = Math.max(1, qty - 1); qv.textContent = qty; refreshPrices(); });
          var qv = el('span', 'mh-qb-qtyval', '1');
          var plus = btn('+', false, function () { qty = Math.min(99, qty + 1); qv.textContent = qty; refreshPrices(); });
          minus.classList.add('mh-qb-qtybtn'); plus.classList.add('mh-qb-qtybtn');
          qrow.appendChild(minus); qrow.appendChild(qv); qrow.appendChild(plus);
          box.appendChild(qrow);
          // Delivery line — fee, or green "FREE DELIVERY applies" — so the
          // total never surprises at checkout. Then the live grand total.
          if (p) {
            var drow = el('div', 'mh-qb-delrow');
            drow.appendChild(el('span', '', T.delivery));
            delEl = el('span', 'mh-qb-delval', '…');
            drow.appendChild(delEl);
            box.appendChild(drow);
            var trow = el('div', 'mh-qb-totalrow');
            trow.appendChild(el('span', '', T.total));
            totalEl = el('span', 'mh-qb-totalval', '');
            trow.appendChild(totalEl);
            box.appendChild(trow);
            shippingCfg(function (s) { ship = s; refreshPrices(); });
          }
        }
        refreshPrices();
        // WhatsApp order by a GUEST (not signed in) → collect name + phone so
        // the order carries real contact details instead of an anonymous
        // "Guest" lead. Signed-in shoppers already have identity on file.
        var gName = null, gPhone = null, gErr = null;
        if (opts.wa && !token()) {
          var cwrap = el('div', 'mh-qb-contact');
          gName = el('input', 'mh-qb-input');
          gName.type = 'text'; gName.autocomplete = 'name';
          gName.placeholder = IS_AR ? 'الاسم' : 'Your name';
          gPhone = el('input', 'mh-qb-input');
          gPhone.type = 'tel'; gPhone.inputMode = 'tel'; gPhone.autocomplete = 'tel';
          gPhone.placeholder = IS_AR ? 'رقم الهاتف' : 'Phone number';
          gErr = el('div', 'mh-qb-input-err');
          cwrap.appendChild(gName); cwrap.appendChild(gPhone); cwrap.appendChild(gErr);
          box.appendChild(cwrap);
        }
        var row = el('div', 'mh-qb-actions');
        row.appendChild(btn(T.cancel, false, close));
        // Saudi store: accept a Saudi mobile (9 digits starting 5, optionally
        // prefixed +966 / 966 / 00966 / a leading 0) OR a legacy Qatar mobile
        // (8 digits starting 3/5/6/7). A bare local number defaults to +966.
        // Returns the normalized +<code><national> or null.
        var normalizeGccPhone = function (v) {
          var s = String(v || '').replace(/[^\d]/g, '');
          if (s.indexOf('00966') === 0) s = s.slice(5);
          else if (s.indexOf('00974') === 0) s = s.slice(5);
          else if (s.indexOf('966') === 0 && s.length > 9) s = s.slice(3);
          else if (s.indexOf('974') === 0 && s.length > 8) s = s.slice(3);
          s = s.replace(/^0+/, '');                     // drop trunk 0 (05x → 5x)
          if (/^5\d{8}$/.test(s))    return '+966' + s; // Saudi mobile (9 digits)
          if (/^[3567]\d{7}$/.test(s)) return '+974' + s; // legacy Qatar mobile
          return null;
        };
        var isFormValid = function () {
          if (!gName || !gPhone) return true; // signed-in, no inputs
          if ((gName.value || '').trim().length < 2) return false;
          return normalizeGccPhone(gPhone.value) !== null;
        };
        var doConfirm = function () {
          var extra = {};
          if (gPhone) {
            var norm = normalizeGccPhone(gPhone.value);
            if (!norm) {
              if (gErr) gErr.textContent = IS_AR ? 'يرجى إدخال رقم قطري صحيح (٨ أرقام تبدأ بـ 3/5/6/7)' : 'Please enter a valid Qatar mobile (8 digits starting 3/5/6/7)';
              gPhone.focus(); return;
            }
            if ((gName.value || '').trim().length < 2) {
              if (gErr) gErr.textContent = IS_AR ? 'يرجى إدخال الاسم' : 'Please enter your name';
              gName.focus(); return;
            }
            extra.custName = gName.value.trim();
            extra.custPhone = norm;
          }
          close();
          cb(Object.assign({ variantId: chosen ? chosen.id : null, variantTitle: (multi && chosen) ? chosen.title : '', qty: qty }, extra));
        };
        if (opts.wa) {
          // WhatsApp flow → green, WhatsApp-branded confirm button. Stays
          // disabled (grey) until guest fields are valid.
          var waConfirm = el('button', 'mh-qb-btn mh-qb-btn--waconfirm');
          waConfirm.type = 'button';
          waConfirm.appendChild(svgIcon([WA_PATH]));
          waConfirm.appendChild(el('span', '', T.wa));
          waConfirm.addEventListener('click', doConfirm);
          row.appendChild(waConfirm);
          var syncWaBtn = function () { waConfirm.disabled = !isFormValid(); };
          if (gName) gName.addEventListener('input', syncWaBtn);
          if (gPhone) gPhone.addEventListener('input', syncWaBtn);
          syncWaBtn();
        } else {
          row.appendChild(btn(T.confirm, true, doConfirm));
        }
        box.appendChild(row);
      });
    });
  }

  /* ── OOS "Notify me" ────────────────────────────────────────────── */
  function notifySubscribe(handle, email, done, fail) {
    var headers = { 'Content-Type': 'application/json' };
    if (token()) headers.Authorization = 'Bearer ' + token();
    var body = { handle: handle };
    if (email) body.email = email;
    fetch(API + '/stock_notify.php', { method: 'POST', headers: headers, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) done(d);
        else fail(d || {});
      })
      .catch(function () { fail({ message: 'Network error' }); });
  }

  function openNotify(handle) {
    // Logged-in customers: one tap, no questions -- the account email is used
    // and a confirmation email (product + related picks) goes out instantly.
    if (token()) {
      var st = statusModal();
      st.placing();
      notifySubscribe(handle, null, function (d) {
        st.close();
        statusModal().successStatic(d.in_stock ? d.message : T.notifyOk);
      }, function (err) {
        st.close();
        if (err && err.need_email) { openNotifyEmail(handle); return; }
        statusModal().error(err.message || '');
      });
      return;
    }
    openNotifyEmail(handle);
  }

  function openNotifyEmail(handle) {
    modal(function (box, close) {
      box.appendChild(el('div', 'mh-qb-title', T.notifyTitle));
      box.appendChild(el('p', 'mh-qb-body', T.notifyBody));
      var inp = document.createElement('input');
      inp.type = 'email'; inp.placeholder = 'you@email.com';
      inp.className = 'mh-qb-input';
      box.appendChild(inp);
      // Prefill for logged-in customers (best effort).
      if (token()) {
        fetch(API + '/customer_profile.php', { headers: { Authorization: 'Bearer ' + token() } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var em = (d && (d.email || (d.user && d.user.email) || (d.customer && d.customer.email))) || '';
            if (em && !inp.value) inp.value = em;
          }).catch(function () {});
      }
      var msg = el('div', 'mh-qb-addr-line', '');
      box.appendChild(msg);
      var row = el('div', 'mh-qb-actions');
      row.appendChild(btn(T.cancel, false, close));
      row.appendChild(btn(T.notifyBtn, true, function () {
        var email = (inp.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { inp.classList.add('mh-qb-shake'); setTimeout(function(){ inp.classList.remove('mh-qb-shake'); }, 500); return; }
        notifySubscribe(handle, email, function (d) {
          msg.textContent = '\u2713 ' + (d.in_stock ? d.message : T.notifyOk); msg.style.color = '#059669'; setTimeout(close, 2200);
        }, function (err) {
          msg.textContent = (err && err.message) || 'Error - try again'; msg.style.color = '#e11d48';
        });
      }));
      box.appendChild(row);
    });
  }

  var BELL_PATH = 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z';

  /* ── PayLater brand logo (admin-uploaded, from bnpl_banners) ─────── */
  var PL_LOGO = null; // null=unfetched, ''=none, else url
  function paylaterLogo(cb) {
    if (PL_LOGO !== null) { cb(PL_LOGO); return; }
    try { var c = sessionStorage.getItem('mh:pllogo'); if (c !== null) { PL_LOGO = c; cb(c); return; } } catch (e) {}
    fetch(API + '/bnpl_banners.php')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        PL_LOGO = (d && d.logo) ? d.logo : '';
        try { sessionStorage.setItem('mh:pllogo', PL_LOGO); } catch (e) {}
        cb(PL_LOGO);
      })
      .catch(function () { PL_LOGO = ''; cb(''); });
  }

  /* ── PayLater choice popup ──────────────────────────────────────────
     Shown for PayLater products before the WhatsApp / 1-Click flow:
     PayLater → dedicated PayLater checkout page; Full payment → proceed().
     The popup shows the PayLater LOGO (not the word "PayLater"). $src tags
     the destination so the PayLater page knows the origin channel. */
  function askPaylater(handle, proceed, src, qty) {
    src = src || 'oneclick';
    qty = qty || 1;
    modal(function (box, close) {
      var head = el('div', 'mh-qb-pl-head');
      box.appendChild(head);
      paylaterLogo(function (logo) {
        if (logo) {
          var im = document.createElement('img');
          im.src = logo; im.alt = 'PayLater'; im.className = 'mh-qb-pl-logo';
          head.appendChild(im);
        } else {
          head.appendChild(el('div', 'mh-qb-title', 'PayLater'));
        }
      });
      box.appendChild(el('div', 'mh-qb-title mh-qb-pl-q', T.plTitle));
      var row = el('div', 'mh-qb-actions mh-qb-actions--stack');

      // PayLater option — logo chip instead of the word.
      var plBtn = el('button', 'mh-qb-btn mh-qb-pl-opt');
      plBtn.type = 'button';
      paylaterLogo(function (logo) {
        if (logo) {
          var im = document.createElement('img');
          im.src = logo; im.alt = 'PayLater'; im.className = 'mh-qb-pl-optlogo';
          plBtn.appendChild(im);
        } else {
          plBtn.appendChild(el('span', '', 'PayLater'));
        }
        plBtn.appendChild(el('span', '', ' — ' + T.plInstall));
      });
      plBtn.addEventListener('click', function () {
        close();
        location.assign((IS_AR ? '/ar' : '') + '/pages/custom-checkout?quick=' + encodeURIComponent(handle)
          + '&qty=' + qty + '&intent=paylater&src=' + src + (src === 'whatsapp' ? '&wa=1' : ''));
      });
      row.appendChild(plBtn);

      row.appendChild(btn(T.plFull, false, function () { close(); proceed(); }));
      box.appendChild(row);
    });
  }

  /* ── Order status popup — white overlay with animated states:
     countdown (cancellable) → placing spinner → animated tick + order id
     + redirect to My Orders, or animated red cross + error details. */
  function statusModal() {
    var ov = document.createElement('div');
    ov.className = 'mh-qb-overlay';
    ov.setAttribute('dir', IS_AR ? 'rtl' : 'ltr');
    var box = document.createElement('div');
    box.className = 'mh-qb-modal mh-qb-status';
    ov.appendChild(box);
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    function close() { ov.remove(); document.body.style.overflow = ''; }
    function render(iconHtmlClass, title, sub, actions) {
      box.textContent = '';
      var ic = el('div', 'mh-qb-st-icon ' + iconHtmlClass);
      if (iconHtmlClass === 'mh-qb-st-spin') {
        ic.appendChild(el('div', 'mh-qb-spinner'));
      } else {
        var NS2 = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(NS2, 'svg');
        svg.setAttribute('viewBox', '0 0 52 52');
        var circ = document.createElementNS(NS2, 'circle');
        circ.setAttribute('cx', '26'); circ.setAttribute('cy', '26'); circ.setAttribute('r', '24');
        circ.setAttribute('class', 'mh-qb-st-circle');
        svg.appendChild(circ);
        var path = document.createElementNS(NS2, 'path');
        path.setAttribute('class', 'mh-qb-st-path');
        path.setAttribute('d', iconHtmlClass === 'mh-qb-st-ok'
          ? 'M14 27 L22 35 L38 18'
          : 'M17 17 L35 35 M35 17 L17 35');
        svg.appendChild(path);
        ic.appendChild(svg);
      }
      box.appendChild(ic);
      box.appendChild(el('div', 'mh-qb-st-title', title));
      if (sub) box.appendChild(el('div', 'mh-qb-st-sub', sub));
      if (actions) box.appendChild(actions);
    }
    return {
      close: close,
      countdown: function (seconds, onCancel, onDone) {
        var left = seconds;
        var cancelled = false;
        var row = el('div', 'mh-qb-actions');
        row.style.justifyContent = 'center';
        row.appendChild(btn(T.cancelBtn, false, function () { cancelled = true; clearInterval(iv); close(); onCancel && onCancel(); }));
        render('mh-qb-st-spin', T.placing, (IS_AR ? 'يبدأ خلال ' : 'Starting in ') + left + 's', row);
        var subEl = box.querySelector('.mh-qb-st-sub');
        var iv = setInterval(function () {
          left--;
          if (left <= 0) { clearInterval(iv); if (!cancelled) { render('mh-qb-st-spin', T.placing, ''); onDone(); } return; }
          if (subEl) subEl.textContent = (IS_AR ? 'يبدأ خلال ' : 'Starting in ') + left + 's';
        }, 1000);
      },
      placing: function () { render('mh-qb-st-spin', T.placing, ''); },
      success: function (orderNo) {
        render('mh-qb-st-ok', IS_AR ? 'تم الطلب بنجاح!' : 'Order placed successfully!',
          orderNo ? (T.orderNo + ' ' + orderNo) : '');
        box.appendChild(el('div', 'mh-qb-st-note', IS_AR ? 'جارٍ تحويلك إلى طلباتي…' : 'Taking you to My Orders…'));
        setTimeout(function () {
          location.assign((IS_AR ? '/ar' : '') + '/pages/my-orders');
        }, 2600);
      },
      successStatic: function (msg) {
        render('mh-qb-st-ok', msg || (IS_AR ? '\u062a\u0645!' : 'Done!'), '');
        setTimeout(close, 2400);
      },
      error: function (msg) {
        var row = el('div', 'mh-qb-actions');
        row.style.justifyContent = 'center';
        row.appendChild(btn(IS_AR ? 'إغلاق' : 'Close', true, close));
        render('mh-qb-st-err', IS_AR ? 'تعذّر إتمام الطلب' : 'Order could not be placed',
          msg || (IS_AR ? 'حاول مرة أخرى أو استخدم السلة.' : 'Please try again or use the cart.'), row);
      }
    };
  }

  function placeWithCountdown(handle, variantId) {
    var st = statusModal();
    st.countdown(4, null, function () { fireOrder(handle, variantId, st); });
  }

  function fireOrder(handle, variantId, st) {
    st = st || statusModal();
    st.placing();
    fetch(API + '/quickbuy_order.php', {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ handle: handle, market: market(), lang: LANG, variant_id: variantId || 0 })
    }).then(function (r) { return r.json().then(function (d) { return { code: r.status, d: d }; }); })
      .then(function (res) {
        var d = res.d || {};
        if (res.code === 428 || d.message === 'setup_required') {
          st.close();
          openSetup(function () { placeWithCountdown(handle, variantId); });
          return;
        }
        if (d.success && d.redirect) {
          // Card path: add the item to the cart, then the prefilled checkout.
          var vid = variantId || currentVariantIdFor(handle);
          var go = function () { location.assign(d.redirect); };
          if (vid) {
            fetch('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            }).then(go).catch(go);
          } else go();
          return;
        }
        if (d.success && d.place && d.payload) {
          // COD: the browser places the order through the same pipeline the
          // custom checkout uses (mh_token satisfies phone verification).
          var payload = d.payload;
          payload.mh_token = token();
          fetch(API + '/web_create_order.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (r2) { return r2.json(); })
            .then(function (o) {
              if (o && o.success) {
                st.success(o.order_number || '');
                // Audit log (fire-and-forget).
                fetch(API + '/quickbuy_order.php', {
                  method: 'POST',
                  headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' },
                  body: JSON.stringify({ handle: handle, market: market(), lang: LANG, stage: 'record', order_number: o.order_number || '' })
                }).catch(function () {});
              } else {
                var detail = (o && o.message) || '';
                if (o && o.errors && o.errors.length) detail += (detail ? ': ' : '') + o.errors.join(' · ');
                st.error(detail);
              }
            })
            .catch(function () { st.error(IS_AR ? 'خطأ في الاتصال — حاول مرة أخرى' : 'Connection error — please try again'); });
          return;
        }
        st.error(d.message || '');
      })
      .catch(function () { st.error(IS_AR ? 'خطأ في الاتصال — حاول مرة أخرى' : 'Connection error — please try again'); });
  }

  function currentVariantIdFor(handle) {
    // PDP: the product form carries the variant. Cards: the quick-add form.
    var scope = document;
    var card = document.querySelector('.mh-card[data-product-handle="' + handle + '"]');
    if (card) scope = card;
    var inp = scope.querySelector('.mh-quick-add-form input[name="id"], #mh-product-form input[name="id"], .mh-variant-id-input');
    return inp ? parseInt(inp.value, 10) || 0 : 0;
  }

  /* ── 1-Click entry point ────────────────────────────────────────── */
  function start(handle, isPaylater, variantId) {
    if (!token()) {
      var ret = encodeURIComponent(location.pathname + location.search);
      location.assign((IS_AR ? '/ar' : '') + '/pages/sign-in?return=' + ret);
      return;
    }
    fetch(API + '/quickbuy_prefs.php', { headers: { Authorization: 'Bearer ' + token() } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ready = d && d.success && d.consent === 1 && d.address;
        var go = function () {
          if (isPaylater) askPaylater(handle, function () { placeWithCountdown(handle, variantId); });
          else placeWithCountdown(handle, variantId);
        };
        if (ready) go();
        else openSetup(go);
      })
      .catch(function () { alert('Network error — please try again'); });
  }

  /* ── Buttons ────────────────────────────────────────────────────── */
  var NS = 'http://www.w3.org/2000/svg';
  function svgIcon(paths, viewBox) {
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', viewBox || '0 0 24 24');
    s.setAttribute('width', '18'); s.setAttribute('height', '18');
    s.setAttribute('fill', 'currentColor');
    paths.forEach(function (dp) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', dp);
      s.appendChild(p);
    });
    return s;
  }
  var WA_PATH = 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z';
  var BOLT_PATH = 'M13 2 3 14h7l-1 8 10-12h-7l1-8z';
  var CARD_PATH = 'M4 5a2 2 0 0 0-2 2v1h20V7a2 2 0 0 0-2-2H4zm18 5H2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7zM5 15h6v2H5v-2z';
  var CART_PATH = 'M7 4h-2l-1 2h2l3.6 7.59-1.35 2.44C7.52 16.37 8.48 18 10 18h9v-2h-9l1.1-2h6.45c.75 0 1.41-.41 1.75-1.03L23 6H6.21L5.27 4H7zm3 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z';

  function buildRow(handle, hasPaylater, cartAction, ctx) {
    var row = el('div', 'mh-qb-btnrow');
    // Without the wide 1-Click button (e.g. Saudi market: WhatsApp + cart
    // only) the two square buttons center instead of hugging one edge.
    if (!featureOn('oneclick')) row.className += ' mh-qb-btnrow--two';
    row.setAttribute('dir', IS_AR ? 'rtl' : 'ltr');

    if (featureOn('whatsapp')) {
      var wa = el('a', 'mh-qb-b mh-qb-b--wa');
      wa.setAttribute('aria-label', T.wa);
      wa.appendChild(svgIcon([WA_PATH]));
      wa.target = '_blank'; wa.rel = 'noopener';
      wa.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        // Full-payment WhatsApp flow: qty popup → mint order → open WhatsApp.
        var waFull = function () {
        qtyVariantModal(handle, { qty: true, wa: true }, function (sel) {
          var url = location.origin + '/products/' + handle;
          var num = (CFG && CFG.whatsapp && CFG.whatsapp.number) || '97431114248';
          waRedirectOverlay(true); // "Redirecting to WhatsApp, please wait…"
          // Open the WhatsApp tab NOW — the Confirm click is a real user
          // gesture, so the browser (incl. mobile Safari/Chrome) won't block
          // it. We navigate this same tab once the order is minted below.
          // Opening inside the async fetch().then() instead would be blocked.
          var IS_MOB = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
          // Desktop pre-opens a tab for WhatsApp Web; mobile navigates the
          // CURRENT tab straight into the app (see openWa) — no new tab.
          var waWin = IS_MOB ? null : window.open('', '_blank');
          function openWa(msg) {
            var text = encodeURIComponent(msg);
            var waMe = 'https://wa.me/' + num + '?text=' + text;
            // WhatsApp is opening now — clear the overlay shortly after.
            setTimeout(function () { waRedirectOverlay(false); }, 700);
            if (IS_MOB) {
              // Open the WhatsApp APP directly. The old approach navigated a NEW
              // tab to wa.me, which showed WhatsApp's "continue to chat / install
              // the app" landing page — forcing a SECOND tap. The whatsapp://
              // deep link opens the installed app in one tap; if it doesn't take
              // over (app missing), fall back to wa.me shortly after.
              var t = setTimeout(function () { location.href = waMe; }, 1200);
              var onHide = function () {
                if (document.hidden) { clearTimeout(t); document.removeEventListener('visibilitychange', onHide); }
              };
              document.addEventListener('visibilitychange', onHide);
              location.href = 'whatsapp://send?phone=' + num + '&text=' + text;
              return;
            }
            if (waWin && !waWin.closed) { try { waWin.location.href = waMe; return; } catch (e2) {} }
            if (!window.open(waMe, '_blank', 'noopener')) location.href = waMe;
          }
          // Mint the WhatsApp Order on the middleware (order no + true price +
          // delivery fee + delivery type + customer identity + confirmation
          // email) IN THE BACKGROUND, then compose the full message. Falls
          // back to the simple message on failure so WhatsApp still opens.
          var headers = { 'Content-Type': 'application/json' };
          if (token()) headers.Authorization = 'Bearer ' + token();
          fetch(API + '/quickbuy_wa_order.php', {
            method: 'POST', headers: headers,
            body: JSON.stringify({ handle: handle, variant_id: sel.variantId || 0, qty: sel.qty, market: market(), lang: LANG, name: sel.custName || '', phone: sel.custPhone || '' })
          })
            .then(function (r) { return r.json(); })
            .then(function (o) {
              if (!o || !o.success) throw 0;
              var fmt = function (v) { return 'QAR ' + Number(v).toFixed(2); };
              var L = [];
              L.push(T.waMsg);
              L.push('*' + T.waOrderId + ':* ' + o.order_no);
              L.push('*' + T.waDate + ':* ' + o.date);
              L.push('');
              L.push('*' + T.waProduct + ':* ' + o.title);
              L.push(url);
              if (sel.variantTitle) L.push('*' + T.variant + ':* ' + sel.variantTitle);
              L.push('*' + T.waQty + ':* ' + o.qty);
              L.push('');
              L.push('*' + T.waPrice + ':* ' + fmt(o.unit_price) + (o.qty > 1 ? ' × ' + o.qty + ' = ' + fmt(o.subtotal) : ''));
              L.push('*' + T.delivery + ':* ' + (o.free_delivery ? T.freeDel : fmt(o.delivery_fee)));
              L.push('*' + T.total + ':* ' + fmt(o.total));
              L.push('*' + T.waDelType + ':* ' + o.delivery_type);
              if (o.customer) {
                L.push('');
                if (o.customer.name)  L.push('*' + T.waName + ':* ' + o.customer.name);
                if (o.customer.phone) L.push('*' + T.waPhone + ':* ' + o.customer.phone);
                if (o.customer.email) L.push('*' + T.waEmail + ':* ' + o.customer.email);
              }
              openWa(L.join('\n'));
            })
            .catch(function () {
              var msg = T.waMsg + '\n' + url;
              if (sel.variantTitle) msg += '\n' + T.variant + ': ' + sel.variantTitle;
              msg += '\n' + T.waQty + ': ' + sel.qty;
              openWa(msg);
            });
        });
        }; // end waFull

        // PayLater product → ask PayLater vs Full first (logo popup). Full
        // runs the normal WhatsApp order; PayLater goes to the PayLater page.
        if (plNow(hasPaylater)) askPaylater(handle, waFull, 'whatsapp');
        else waFull();
      });
      row.appendChild(wa);
    }

    if (featureOn('oneclick')) {
      var oc = el('button', 'mh-qb-b mh-qb-b--main');
      oc.type = 'button';
      oc._pl = false;
      var renderOneClick = function () {
        while (oc.firstChild) oc.removeChild(oc.firstChild);
        oc.className = 'mh-qb-b mh-qb-b--main';
        oc.appendChild(svgIcon([BOLT_PATH]));
        oc.appendChild(el('span', '', T.oneclick));
        oc._pl = false;
      };
      var renderPlBuy = function () {
        while (oc.firstChild) oc.removeChild(oc.firstChild);
        oc.className = 'mh-qb-b mh-qb-b--plbuy';
        // "Buy on" + the admin-uploaded PayLater brand mark, matching the
        // choice popup and the product-card badge, which both show the logo
        // rather than the word. aria-label carries the full phrase so the
        // button still announces as "Buy on PayLater" when the logo replaces
        // the word. If no logo is configured, fall back to the old icon +
        // full text so the button is never wordless.
        oc.setAttribute('aria-label', T.buyPaylater);
        oc.appendChild(el('span', '', T.buyOn));
        // Set BEFORE paylaterLogo(): its callback runs synchronously on a
        // sessionStorage hit, so leaving this until after meant the guard below
        // saw _pl still false and dropped the logo on every visit except the
        // very first (when the fetch is genuinely async).
        oc._pl = true;
        paylaterLogo(function (logo) {
          if (!oc._pl) return;              // re-rendered as 1-Click meanwhile
          if (logo) {
            var im = document.createElement('img');
            im.src = logo; im.alt = 'PayLater'; im.className = 'mh-qb-b-pllogo';
            oc.appendChild(im);
          } else {
            while (oc.firstChild) oc.removeChild(oc.firstChild);
            oc.appendChild(svgIcon([CARD_PATH]));
            oc.appendChild(el('span', '', T.buyPaylater));
          }
        });
      };
      renderOneClick();
      oc.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        // Mobile bar, PayLater-eligible → straight into the PayLater checkout.
        if (oc._pl) { goPaylaterCheckout(handle); return; }
        qtyVariantModal(handle, { qty: false }, function (sel) {
          start(handle, plNow(hasPaylater), sel.variantId);
        });
      });
      // "Buy on PayLater" shows ONLY on products where PayLater is actually a
      // payment option — decided by the AUTHORITATIVE bnpl_check result (PDP_PL),
      // never the document-wide badge (which matches related-product cards on the
      // page and would flip almost every PDP to PayLater). Cards use their own
      // per-card badge (hasPaylater), which is correctly scoped.
      if (ctx === 'bar') {
        // Mobile sticky bar: swap 1-Click → Buy on PayLater only when eligible.
        onPlResolved(function (elig) { if (elig) renderPlBuy(); });
        row.appendChild(oc);
      } else if (ctx === 'card') {
        // 1-Click is a product-details-only action — never rendered on cards.
        row.className += ' mh-qb-btnrow--two';
      } else { // desktop PDP sidebar
        // Eligible products used to have the 1-Click button REMOVED here,
        // which left the row as just WhatsApp + cart and dropped the single
        // highest-intent action on a PayLater product. Swap it for "Buy on
        // PayLater" instead -- same treatment the mobile sticky bar already
        // gets, so the two surfaces finally agree.
        row.appendChild(oc);
        onPlResolved(function (elig) { if (elig) renderPlBuy(); });
      }
    }

    var ct = el('button', 'mh-qb-b mh-qb-b--cart');
    ct.type = 'button';
    ct.setAttribute('aria-label', T.cart);
    ct.appendChild(svgIcon([CART_PATH]));
    ct.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var doCartAdd = function () {
        qtyVariantModal(handle, { qty: true }, function (sel) {
          if (!sel.variantId) { cartAction(); return; }
          var f = document.createElement('form');
          f.method = 'post'; f.action = '/cart/add';
          [['id', sel.variantId], ['quantity', sel.qty]].forEach(function (kv) {
            var i = document.createElement('input');
            i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
            f.appendChild(i);
          });
          document.body.appendChild(f);
          f.submit();
        });
      };
      // PayLater product → ask PayLater vs Full first. PayLater → PayLater
      // checkout page; Full → normal add-to-cart.
      if (plNow(hasPaylater)) askPaylater(handle, doCartAdd, 'cart');
      else doCartAdd();
    });
    row.appendChild(ct);
    return row;
  }

  /* ── Authoritative PayLater eligibility for the PDP ─────────────────
     The PayLater badge is injected by a SEPARATE async fetch in the product
     layout, so a one-shot DOM check at hydrate time races it and often reads
     false — leaving WhatsApp / 1-Click / Cart without the payment choice.
     Resolve eligibility directly from the BNPL API and read it at CLICK time. */
  var PDP_PL = null; // null = unknown, true/false = resolved (PDP only)
  var PDP_PL_CBS = [];
  // Register a callback for when PDP PayLater eligibility resolves. Fires
  // immediately if already known. Used to upgrade the mobile bar button.
  function onPlResolved(cb) {
    if (PDP_PL !== null) { cb(PDP_PL); return; }
    PDP_PL_CBS.push(cb);
  }
  function setPdpPl(v) {
    PDP_PL = v;
    var cbs = PDP_PL_CBS; PDP_PL_CBS = [];
    cbs.forEach(function (f) { try { f(v); } catch (e) {} });
  }
  function resolvePdpPaylater() {
    if (location.pathname.indexOf('/products/') === -1) return;
    fetch(location.pathname.split('?')[0] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.id) return;
        fetch(API + '/bnpl_check.php?shopify_product_ids=' + p.id)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            setPdpPl(!!(d && d.bnpl_enabled && d.products && d.products[0] && d.products[0].eligible));
          })
          .catch(function () {});
      })
      .catch(function () {});
  }
  // Navigate straight into the PayLater checkout for the currently-selected
  // variant (same target as the desktop EMI-box "Buy on PayLater" button).
  function goPaylaterCheckout(handle) {
    var vEl = document.querySelector('.mh-variant-id-input, #mh-product-form [name="id"], form[action^="/cart/add"] [name="id"]');
    var v = vEl && vEl.value;
    location.assign((IS_AR ? '/ar' : '') + '/pages/custom-checkout?quick=' + encodeURIComponent(handle)
      + (v ? '&v=' + encodeURIComponent(v) : '') + '&qty=1&intent=paylater&src=pdp');
  }
  // Live check used inside click handlers. On a PDP the API result wins; on
  // cards it falls back to the server-rendered badge captured at build time.
  function plNow(captured) {
    // PayLater is Qatar-only — never offer it in the Saudi market, so the
    // WhatsApp / 1-Click / cart flows skip the PayLater choice popup entirely.
    if (market() === 'sa') return false;
    // Match /products/ AND /ar/products/ — the authoritative API result wins.
    var onPdp = location.pathname.indexOf('/products/') !== -1;
    if (onPdp && PDP_PL !== null) return PDP_PL;
    if (captured) return true;
    // Document-wide badge fallback ONLY on a PDP (one product on the page). On
    // listing pages `captured` already reflects THIS card's own badge — never
    // query the whole document or every card inherits one product's eligibility.
    if (onPdp) return !!document.querySelector('.mh-pl-card-badge, [data-pl-badge], .mh-pdp-paylater');
    return false;
  }

  /* ── Card + PDP injection ───────────────────────────────────────── */
  function hydrateCards(root) {
    if (!featureOn('oneclick') && !featureOn('whatsapp')) return;
    var cards = (root || document).querySelectorAll('.mh-card:not([data-qb-done])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-qb-done', '1');
      var handle = card.getAttribute('data-product-handle');
      var imgWrap = card.querySelector('.mh-card-image-wrap');
      if (!handle || !imgWrap) return;
      if (card.getAttribute('data-available') === 'false') {
        // OOS: no centered image overlay — the grey "Notify me" bar in the
        // delivery slot (.mh-card-notify) handles the restock alert via the
        // delegated listener below.
        return;
      }
      var hasPl = !!card.querySelector('.mh-pl-card-badge');
      var row = el('div', 'mh-qb-imgrow');
      row.appendChild(buildRow(handle, hasPl, function () {
        var f = card.querySelector('.mh-quick-add-form');
        var b = f && f.querySelector('button');
        // Already asked by buildRow -> bypass the delegated PayLater listener.
        if (b) plBypass(function () { b.click(); });
        else if (f && f.requestSubmit) f.requestSubmit();
        else location.assign('/products/' + handle);
      }, 'card'));
      imgWrap.appendChild(row);
    });
  }

  // Delegated: the grey "Notify me" bar in an OOS card's delivery slot
  // (.mh-card-notify, rendered by product-card-new.liquid) opens the restock
  // alert. Delegation covers AJAX-injected cards and works even when the
  // quick-buy overlay is off.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.mh-card-notify') : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    var h = t.getAttribute('data-notify-handle');
    if (h) openNotify(h);
  }, true);

  function hydratePdp() {
    if (!featureOn('oneclick') && !featureOn('whatsapp')) return;
    // Multiple slots per PDP: desktop sidebar + the mobile sticky bar.
    var slots = document.querySelectorAll('.mh-qb-pdp-slot:not([data-qb-done])');
    Array.prototype.forEach.call(slots, hydratePdpSlot);
  }

  function hydratePdpSlot(slot) {
    slot.setAttribute('data-qb-done', '1');
    // Section heading — sidebar slot only (the mobile sticky bar has no room).
    if (!slot.classList.contains('mh-qb-pdp-slot--bar')) {
      slot.appendChild(el('div', 'mh-qb-pdp-heading', T.buyOptions));
    }
    var handle = slot.getAttribute('data-handle');
    var oos = slot.getAttribute('data-oos') === '1';
    if (!handle) return;
    if (oos) {
      var nb = el('button', 'mh-qb-b mh-qb-b--notify');
      nb.type = 'button';
      nb.appendChild(svgIcon([BELL_PATH]));
      nb.appendChild(el('span', '', T.notify));
      nb.addEventListener('click', function () { openNotify(handle); });
      var nrow = el('div', 'mh-qb-btnrow');
      nrow.appendChild(nb);
      slot.appendChild(nrow);
      return;
    }
    var hasPl = !!document.querySelector('.mh-pl-card-badge, [data-pl-badge], .mh-pdp-paylater');
    var isBar = slot.classList.contains('mh-qb-pdp-slot--bar');
    slot.appendChild(buildRow(handle, hasPl, function () {
      var b = document.querySelector('#mh-product-form .mh-btn-add-cart');
      if (b) plBypass(function () { b.click(); });
    }, isBar ? 'bar' : 'sidebar'));
  }

  /* ── PayLater choice on the THEME'S OWN buy buttons ────────────────
     The PayLater-vs-Full choice used to exist only on the quick-buy row
     that hydrateCards()/hydratePdp() inject. Both of those return early
     when WhatsApp and 1-Click are switched off in the middleware, so
     disabling those two ALSO removed the payment choice: the "+" on a
     PayLater card and Add to Cart on a PayLater PDP went straight into
     the cart at the full price, with no way to reach the instalment flow.

     The buttons below are the theme's own, so this listener is
     deliberately independent of featureOn() and binds whenever the
     module loads. Capture phase, because the theme's AJAX add-to-cart
     handler is bound on the same elements and would otherwise win. */
  var PL_BYPASS = false;   // true while quick-buy drives a native button itself
  function plBypass(fn) {
    PL_BYPASS = true;
    try { fn(); } finally { setTimeout(function () { PL_BYPASS = false; }, 0); }
  }

  function pdpHandle() {
    var s = document.querySelector('.mh-qb-pdp-slot[data-handle]');
    if (s && s.getAttribute('data-handle')) return s.getAttribute('data-handle');
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  document.addEventListener('click', function (e) {
    if (PL_BYPASS) return;                       // quick-buy already asked
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest(
      '.mh-quick-add-form button, .mh-quick-add-form [type="submit"], '
      + '#mh-product-form .mh-btn-add-cart');
    if (!t || t.getAttribute('data-mh-pl-asked') === '1') return;

    var card = t.closest('.mh-card');

    // On a PDP, paylater-checkout-router.js already intercepts this same
    // button and shows its own, richer payment-choice popup. Both firing
    // stacked two dialogs on top of each other. The router owns the PDP;
    // this listener owns the listing cards, which the router never binds.
    if (!card && window.mhStartPaylater) return;

    var handle = card ? card.getAttribute('data-product-handle') : pdpHandle();
    if (!handle) return;

    // On a listing, eligibility is THIS card's own badge. On a PDP, plNow()
    // prefers the resolved BNPL API answer over the injected badge.
    if (!plNow(card ? !!card.querySelector('.mh-pl-card-badge') : false)) return;

    e.preventDefault();
    e.stopPropagation();
    askPaylater(handle, function () {
      // Full payment: replay the click the shopper actually made, so the
      // theme's own add-to-cart runs exactly as it normally would.
      t.setAttribute('data-mh-pl-asked', '1');
      plBypass(function () { t.click(); });
      setTimeout(function () { t.removeAttribute('data-mh-pl-asked'); }, 1500);
    }, card ? 'card' : 'pdp');
  }, true);

  function boot() {
    resolvePdpPaylater(); // authoritative PDP PayLater eligibility (click-time)
    loadCfg(function () {
      hydrateCards(document);
      hydratePdp();
    });
    window.addEventListener('mh:product-cards-injected', function (ev) {
      hydrateCards((ev.detail && ev.detail.container) || document);
    });
    // Infinite scroll / filters / ExpertRec inject cards without firing the
    // event above — watch the DOM like the fulfilment hydrator does. Our own
    // injections re-trigger the observer but no-op on [data-qb-done] cards.
    var moT = null;
    var mo = new MutationObserver(function () {
      clearTimeout(moT);
      moT = setTimeout(function () {
        if (!CFG) return;
        hydrateCards(document);
        hydratePdp();
      }, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
